import React, { useEffect, useState } from "react";
import { PDFViewer, PDFDownloadLink } from "@react-pdf/renderer";
import PaymentDocument from "./PaymentDocument";
import { useLocation, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import axios from "axios";

const PaymentPreview = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const pvPrintData = location.state?.pvPrintData;
  console.log("pvPrintData in payment preview::", pvPrintData);

  const [paymentData, setPaymentData] = useState([]);
  const [loading, setLoading] = useState(true);

  const onBack = () => navigate("/payment");

  useEffect(() => {
    if (pvPrintData?.PV_NO) {
      fetchPaymentReport();
    }
  }, [pvPrintData]);

  const fetchPaymentReport = async () => {
    try {
      const apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
      const companyCode = localStorage.getItem("companyCode") || "-";
      const department =
        localStorage.getItem("currentSelectedDepartment") || "-";

      if (!apiPaths[0]) return;

      const apiUrl = `${
        apiPaths[0].API_CONFIG
      }/api/CRMReportGenerator/${companyCode}/PYMT_PRINT/${pvPrintData.PV_NO.trim()}/${department}/${pvPrintData.JVTYPE}/-/-/-/-`;

      const response = await axios.get(apiUrl);
      // console.log("Payment Report Data:", response.data);

      // setPaymentData(response.data);

      // const filteredData = Array.isArray(response.data)
      //   ? response.data.filter((item) => item.pdc_acc === "Y")
      //   : [];

      setPaymentData(response.data);
    } catch (err) {
      console.error("Error fetching payment report:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-4">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-normal my-4">Payment Print Preview</h2>

        <button
          onClick={onBack}
          className="mb-3 relative bg-gray-600 text-white font-medium text-[17px] px-2 py-[0.25em] pl-3 h-[1.8em] rounded-[0.9em] flex items-center overflow-hidden cursor-pointer group"
        >
          <span className="mr-10">Back</span>
          <div className="absolute right-[0.3em] bg-white h-[1.4em] w-[1.4em] rounded-[0.7em] flex items-center justify-center transition-all duration-300 group-hover:w-[calc(100%-0.6em)] active:scale-95">
            <FaArrowLeft className="text-gray-600" />
          </div>
        </button>
      </div>

      <div className="flex flex-col items-center h-screen">
        {loading ? (
          <div className="text-center text-gray-500 mt-10">
            Loading Payment Data...
          </div>
        ) : !pvPrintData || pvPrintData.length === 0 ? (
          <div className="text-center text-gray-500 mt-10">
            No Payment Voucher data available
          </div>
        ) : (
          <>
            <div className="w-full h-screen border border-gray-300 mb-4">
              <PDFViewer width="100%" height="100%">
                <PaymentDocument
                  paymentData={paymentData}
                  
                />
              </PDFViewer>
            </div>

            <div className="mt-4 mb-6">
              <PDFDownloadLink
                document={
                  <PaymentDocument
                    pvPrintData={pvPrintData}
                    paymentData={paymentData}
                  />
                }
                fileName={`PaymentVoucher_${pvPrintData?.PV_NO || "print"}.pdf`}
                className="bg-blue-500 text-white px-4 py-2 rounded"
              >
                {({ loading }) =>
                  loading ? "Preparing PDF..." : "Download Payment Voucher"
                }
              </PDFDownloadLink>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentPreview;
